import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { H1, A } from 'components/Typography';
import Doctor from 'products/nomad_insurance/assets/img/birds/doctor.png';
import UnitedHealthcare from 'products/nomad_insurance/assets/img/logos/united-healthcare.png';
import { fetchInsuranceCard } from './state';
import {
  HospitalSearchContainer,
  Content,
  TextContainer,
  EmText,
  BoldText,
  Text,
  Illustration,
  Logo
} from './styled';

const HospitalSearch = () => {
  const dispatch = useDispatch();
  const { insuranceCard, isLoading } = useSelector(
    (state) => state.nomadInsurance.hospitalSearch
  );

  useEffect(() => {
    if (!insuranceCard) {
      dispatch(fetchInsuranceCard());
    }
  }, [insuranceCard, dispatch]);

  if (isLoading) {
    return <HospitalSearchContainer bg="orange" isLoading />;
  }

  const HospitalNetworkText = () => {
    if (!insuranceCard) {
      return (
        <>
          <BoldText>USA</BoldText>
          <Text>
            When you are in the United States, it is recommended that you go to an
            in-network hospital. If you have coverage in the US, or are an American
            eligible for the 15 day incidental home country coverage, please log in and
            sign up to see which hospital network you belong to (UnitedHealthcare or First
            Health).
          </Text>
        </>
      );
    }
    if (!insuranceCard[0].coveragePossibleUS) {
      return null;
    }
    return (
      <>
        <BoldText>USA</BoldText>
        <Text>
          When you are in the United States, it is recommended that you go to an
          in-network hospital. Search for hospitals in your area here:{' '}
          <>
            <A variant="dark" href="https://us1.welcometouhc.com/find-a-doctor">
              United Health Hospital Search
            </A>
            <Logo>
              <img src={UnitedHealthcare} alt="Logo of United Healthcare" />
            </Logo>
          </>
        </Text>
      </>
    );
  };

  return (
    <HospitalSearchContainer bg="orange">
      <H1>How do I choose a hospital?</H1>
      <Content>
        <TextContainer>
          <EmText>With SafetyWing, you can go to any hospital and get covered.</EmText>
          <Text>
            The recommended procedure to get assistance with choosing a hospital, is to
            call <A href="tel:+18666352163">+1 866-635-2163</A> (free from Skype). They
            will often recommend a hospital they have dealt with before, which will make
            the claims process easier for you.
          </Text>
          <Text>
            If you want to do research on hospitals in your area ahead of time just in
            case, a lot of people choose to use Google Maps and read reviews from other
            travelers. There will often be comments on how customer service oriented the
            hospital is. Private hospitals are usually friendlier to international
            insurance holders than public hospitals.
          </Text>
          <HospitalNetworkText />
        </TextContainer>
        <Illustration>
          <img src={Doctor} alt="Doctor bird holding a clipboard" />
        </Illustration>
      </Content>
    </HospitalSearchContainer>
  );
};

export default HospitalSearch;
